import { xCore, xCoreHelper } from "./core";
import { LayersTree } from "./layers_tree";
import {URN as NSURN } from "./utils/urn";
import { NSServerCalls } from "./utils/servercalls";
import { NSMessages } from "./utils/messages";
import { NSGoTo } from "./go_to";
import { NSPageLabels } from "./page_labels";
import { NSToolDraw } from "./tool_draw";
import { NSObjDetailsGeo } from "./obj_details_geo";
import { NSFunctions } from "./utils/functions";
import { NSDataModelInfo } from "./data_model_info";
import { NSDataTypes } from "./utils/data_types";
import { NSGeoJson } from "./utils/geojson";
import { Overlays } from "./overlays";

export let NSMiniClientMain = {};

NSMiniClientMain.init = function ()
{
    if(xCoreHelper.f_page_is_in_mini_client_mode())
    {
        init();
        o_edit.init();
    }
    
}
NSMiniClientMain.f_get_current_client_info = function()
{
    let o_client_info = private_objs.o_mini_client_cfg.clients[private_objs.miniclient_input.client];
    return o_client_info;
}

/**
 * 
 * @param {string} s_table_internal_name 
 * @returns {Array<string>}
 */
NSMiniClientMain.f_get_table_property_whitelist = function(s_table_internal_name)
{
    let a_property_whitelist =  private_objs.o_mini_client_cfg.property_whitelist[s_table_internal_name];
    return a_property_whitelist;
}

NSMiniClientMain.f_on_map_obj_select = function(s_record_urn)
{
    // alert("s_record_urn= " + s_record_urn)
    if(private_objs.miniclient_input.b_edit != true)
    {
        window.parent.postMessage({event_id: 'SIGObjectSelected',  data: { urn: s_record_urn }},"*");
    }
}
/**
 * 
 * @returns bool
 */
NSMiniClientMain.f_map_obj_select_should_be_canceled = function()
{
    //let b_id_submited = (private_objs.miniclient_input.id != null &&  private_objs.miniclient_input.id != '' ) ? true : false;
    let b_layers = private_objs.miniclient_input.b_layers ? true : false;
    //let b_edit = private_objs.miniclient_input.b_edit ? true : false;
    
    // if there are no active layers, there's no point on selection, and it would destroy the initial selection of a submited object
    let b_cancel_map_selection = !b_layers; 
    
    return b_cancel_map_selection;
}

/**
 * 
 * @returns bool
 */
NSMiniClientMain.f_obj_details_info_area_should_remain_closed = function()
{
    //let b_id_submited = (private_objs.miniclient_input.id != null &&  private_objs.miniclient_input.id != '' ) ? true : false;
    let b_layers = private_objs.miniclient_input.b_layers ? true : false;
    //let b_edit = private_objs.miniclient_input.b_edit ? true : false;
    let b_on_show_single_obj_show_info = private_objs.miniclient_input.b_on_show_single_obj_show_info ? true : false;
    

    /**
        if there are no active layers, it is assumed that there is only one object active
        and only if request the info area will be shown
    */
    let b_obj_details_info_area_should_remain_closed = ( !b_layers && !b_on_show_single_obj_show_info ) ? true : false; 
    
    return b_obj_details_info_area_should_remain_closed;
}




let private_objs = {
    o_mini_client_cfg: null,
    a_validUrlParameters: null,
    miniclient_input: {
        client: null,   // string
        b_layers: null, // boolean
        b_edit: null,   // boolean
        id: null        // string

        ,
        b_on_show_single_obj_show_info: null
    },     // object containing key value pairs of QS input parameters
    o_details: null,     // info of object being edited (corresponding to id in QueryString), object received from NSObjDetails
    o_select: {
        o_geo_sel_highlight: null, //	{NSObjDetailsGeo.objs.GeoHighlight}
    }, 
    o_edit: {
        e_div_mini_client_edit_toolbar_holder: null,
        o_geo_highlight: null, //	{NSObjDetailsGeo.objs.GeoHighlight}
    },

    o_CONSTS:
    {
        s_ID_COL_NAME_FOR_ALL_TABLES: "id"
    }

}

function init()
{
    private_objs.o_mini_client_cfg = xCore.mini_client_cfg;
    private_objs.a_validUrlParameters = ['client', 'layers', 'edit', 'id', 'on_show_single_obj_show_info'];

    private_objs.o_edit.e_div_mini_client_edit_toolbar_holder = document.getElementById("mini-client-edit-toolbar");

    f_run();
}


function f_run()
{
    f_process_qs_input();
    f_start();
}

function f_process_qs_input()
{
    //client=oqspa&layers=true&edit=false&id=1234
    //client=wingoi_arvore&layers=true&edit=false&id=1234
    let sPageURL = window.location.search.substring(1);

    let sURLVariables = sPageURL.split('&');
    
    let f_convert_parameter_to_bool = (s_param_name) => ['layers', 'edit', 'on_show_single_obj_show_info'].indexOf(s_param_name)>-1;

    for (let i = 0; i < sURLVariables.length; i++) {
        let a_parameter_i = sURLVariables[i].split('=');
        if( private_objs.a_validUrlParameters.includes( a_parameter_i[0] ) ){
            if( f_convert_parameter_to_bool(a_parameter_i[0]) )
            {
                private_objs.miniclient_input[ "b_" + a_parameter_i[0] ] = decodeURIComponent(a_parameter_i[1]) == 'true';
            }
            else
            {
                private_objs.miniclient_input[ a_parameter_i[0] ] = decodeURIComponent(a_parameter_i[1])
            }
        }
    }

}

function f_start()
{

    
    let f_load_table_cb = function (b_error, s_message)
    {
        if (b_error)
        {
            let s_message = NSPageLabels.f_get_label_text_by_internal_name("common_error_executing_service");
            NSMessages.f_show_error(s_message);
            throw new Error(s_message);
            return;
        }
        
        if(private_objs.miniclient_input.b_layers == true)
        {
            f_enable_layers();
        }

        if(private_objs.miniclient_input.id != null && private_objs.miniclient_input.id != '')
        {
            f_start_part_2();
        }
    }
    
    
    let o_client_info = NSMiniClientMain.f_get_current_client_info();
    let s_schema_internal_name = o_client_info.schema;
    let s_table_internal_name = o_client_info.table;
    let s_table_urn = NSURN.f_create_table_urn(s_schema_internal_name, s_table_internal_name);

    let o_in = 
    {			
        b_full_info: false,
        s_table_urn: s_table_urn
    }
    
    NSDataModelInfo.f_load_table(o_in, f_load_table_cb);

}

/**
 * @summary gets input id, tries to get object data, if it exists stores it and centers map on it. Finally
 * calls f_start_part_3 so the startup process may continue.
 */
function f_start_part_2()
{

    let s_id = private_objs.miniclient_input.id;
    f_go_to_object_by_id(s_id,
    function(o_details)
    {
        private_objs.o_details = o_details;
        f_start_part_3();
    });

}

/**
 * @summary To be called after a successful creation or edition of an object
 */
function f_reload_object_and_edit_data()
{
    f_start_part_2();
}

function f_start_part_3()
{
    if(private_objs.miniclient_input.b_edit == true)
    {
        o_edit.f_start();
    }
}

function f_enable_layers()
{
    let o_client_info = NSMiniClientMain.f_get_current_client_info();

    let a_layers = o_client_info.layers;
    a_layers.forEach( (o_layer_info_i) => 
    {
        /*
            layer_info example:
            {
                "name": "arvore____nao_abatidas",
                "type": "vector",
                "geometry": "geom",
                "urn": "urn__SEP__table__SEP__municipio__SEP__arvore"            
            }
        */

        let s_geoserver_layer_name = o_layer_info_i.name;

        LayersTree.f_select_layer_by_geoserver_layer_name(s_geoserver_layer_name);

    });
}

function f_go_to_object_by_id(s_id, f_callback)
{
    //let this_ = this;

    let o_client_info = NSMiniClientMain.f_get_current_client_info();



    //call AdvancedSearch
    let s_schema_internal_name = o_client_info.schema;
    let s_table_internal_name = o_client_info.table;
    let s_table_urn = NSURN.f_create_table_urn(s_schema_internal_name, s_table_internal_name)

    let o_condition_param = {"column_internal_name": o_client_info.key_column, "value": s_id, "operator": "="}

    let o_as_options_input =
    {
        "table_urn": s_table_urn,
        "condition_params": [o_condition_param]
    };


    
    let o_promise_res = NSServerCalls.f_advanced_search(o_as_options_input);

    o_promise_res
    .then( (o_resp) =>
    {
        if(o_resp.success)
        {
            if( o_resp.column_internal_names && o_resp.column_internal_names.length > 0
                && o_resp.rows && o_resp.rows.length > 0)
            {
                const s_ID_COL_NAME_FOR_ALL_TABLES = private_objs.o_CONSTS.s_ID_COL_NAME_FOR_ALL_TABLES;
                let index_of_key_col = o_resp.column_internal_names.indexOf(s_ID_COL_NAME_FOR_ALL_TABLES);
                let s_record_id = o_resp.rows[0].values[index_of_key_col];
                let s_urn = NSURN.f_create_record_urn(s_schema_internal_name, s_table_internal_name, s_record_id);
                
                //this_.f_go_to_object_by_urn(s_urn);
                f_go_to_object_by_urn(s_urn, f_callback);
                
            }
            else
            {
                if(private_objs.miniclient_input.b_edit == true)
                {
                    let s_message = "Não foi encontrado um objecto, grave uma geometria para criar um objecto com o id submetido."
                    NSMessages.f_show_information(s_message);
                    f_callback(null);
                }
                else
                {
                    let s_message = "Não foi encontrado um objecto correspondente aos dados submetidos."
                    NSMessages.f_show_information(s_message);
                    o_edit.f_hide_toolbar();
                }
                
                
            }
        }
    } )
    .catch( (o_resp) =>
    {
        let s_message = "Error executing service."
        NSMessages.f_show_error(s_message);

        console.log(s_message);
        if(o_resp != null)
        {
            console.log(o_resp);
        }
    });
}

function f_go_to_object_by_urn(s_urn, f_callback)
{
    NSGoTo.f_go_to_urn(s_urn, f_callback);
}

//Edit Section:

let o_edit = 
{
    init: function()
    {
        if( private_objs.o_geo_highlight != null ) {  private_objs.o_geo_highlight.f_remove_all(); }
        private_objs.o_geo_highlight = new NSObjDetailsGeo.objs.GeoHighlight();

        this.f_create_html();
    },
    
    f_create_html: function()
    {
        let this_ = this;

        let s_label_obj_details_edit_button_save_tooltip = NSPageLabels.f_get_label_text_by_internal_name("obj_details_edit_button_save_tooltip");
        
        let s_html = `<button id="mini_client_save_button" type="button" class="btn btn-light" title="${s_label_obj_details_edit_button_save_tooltip}"><img src="${xCore.application.images_base_path}/common/download.svg" alt="${s_label_obj_details_edit_button_save_tooltip}" width="16" height="16"></button>`;

        NSFunctions.f_dom_elem_append_dom_childs_by_html(private_objs.o_edit.e_div_mini_client_edit_toolbar_holder, s_html);
        document.getElementById("mini_client_save_button").onclick = function()
        {
			this_.f_execute_save();
        };
        
        this.f_hide_toolbar();
    },

    f_hide_toolbar: function()
    {
        private_objs.o_edit.e_div_mini_client_edit_toolbar_holder.style.display = 'none';
    },

    f_show_toolbar: function()
    {
        private_objs.o_edit.e_div_mini_client_edit_toolbar_holder.style.display = '';
    },
    
    f_set_toolbar_buttons_visibility: function()
    {

        // Adjusting DrawTool:
        let o_client_info = NSMiniClientMain.f_get_current_client_info();
        let s_key_col = o_client_info.key_column;
        let s_schema_internal_name = o_client_info.schema;
        let s_table_internal_name = o_client_info.table;
        let s_geometry_internal_name = o_client_info.geometry;

        let o_col_info = NSDataModelInfo.f_get_field_info(s_schema_internal_name, s_table_internal_name, s_geometry_internal_name);
        let s_geometry_type = o_col_info.data_type;
        if(NSDataTypes.f_geometry_type_is_point(s_geometry_type))
        {
            NSToolDraw.f_polyline_hide();
            NSToolDraw.f_draw_polygon_hide();
        }
        else if(NSDataTypes.f_geometry_type_is_polyline(s_geometry_type))
        {
            NSToolDraw.f_draw_marker_hide();
            NSToolDraw.f_draw_polygon_hide();
        }
        else //if (NSDataTypes.f_geometry_type_is_polygon(s_geometry_type))
        {
            NSToolDraw.f_draw_marker_hide();
            NSToolDraw.f_polyline_hide();
        }
    },


    f_start: function()
    {
        this.f_start_logic();
    },

    f_start_logic: function()
    {
        if(private_objs.miniclient_input.id == null || private_objs.miniclient_input.id == '' )
        {
            let s_message = 'A edição/criação de objectos só é possível com a submissão de um id válido.';
            NSMessages.f_show_information(s_message);
            return;
        }

        this.f_set_toolbar_buttons_visibility();
        this.f_show_toolbar();

        //if exist, clean geometry highlights
        if( private_objs.o_geo_highlight != null ) {  private_objs.o_geo_highlight.f_remove_all(); }
        private_objs.o_geo_highlight = new NSObjDetailsGeo.objs.GeoHighlight();

        //preparing
        let o_client_info = NSMiniClientMain.f_get_current_client_info();
        let s_key_col = o_client_info.key_column;
        let s_schema_internal_name = o_client_info.schema;
        let s_table_internal_name = o_client_info.table;
        let s_geometry_internal_name = o_client_info.geometry;

        let o_col_info = NSDataModelInfo.f_get_field_info(s_schema_internal_name, s_table_internal_name, s_geometry_internal_name);

        let o_details = private_objs.o_details;
        let s_feature_urn = null;
        let o_geojson_feature_geometry = null;

        //adding geometry to highlight
        if(o_details != null)
        {
            s_feature_urn = o_details.s_urn;
            o_geojson_feature_geometry = private_objs.o_details.feature.properties[s_geometry_internal_name];
    
            let s_guid = NSFunctions.guidGenerator();
            let b_is_icon = false;
            let a_icon_size_xy = null; 
    
            let o_style_simple = new NSObjDetailsGeo.objs.GeoHighlightStyleSimpleIn({
                b_add_displacement_to_highlight_an_icon: 
                    xCoreHelper.f_use_icon_auto_vetical_displacement() && b_is_icon,
                a_icon_size_xy: a_icon_size_xy	//[width, height]
            });
    
            let o_geo_in = new NSObjDetailsGeo.objs.AddFromGeojsonGeometryIn({
                s_guid: s_guid,
                urn: s_feature_urn,
                o_geojson_feature_geometry: o_geojson_feature_geometry,
                style_simple: o_style_simple						
            });
            private_objs.o_geo_highlight.f_add_from_geojson_geometry(o_geo_in);
        } 


        //Enabling TooDraw with current geometry value:
        let s_geometry_type = o_col_info.data_type;
        if(NSDataTypes.f_geometry_type_is_point(s_geometry_type))
        {
            NSToolDraw.f_draw_marker_enable(o_geojson_feature_geometry);
        }
        else if(NSDataTypes.f_geometry_type_is_polyline(s_geometry_type))
        {
            NSToolDraw.f_draw_polyline_enable(o_geojson_feature_geometry);
        }
        else //if (NSDataTypes.f_geometry_type_is_polygon(s_geometry_type))
        {
            /* doesn't work because openlayers, when starts to draw a new polygon destroys empty multipolygon and returns a polygon
            if(o_geojson_feature_geometry == null
                && NSDataTypes.f_geometry_type_is_multipolygon(s_geometry_type))
            {
                o_geojson_feature_geometry = NSGeoJson.f_get_empty_geojson_feature_geometry_of_type_multipolygon();
            }
            */
        
            //for polygon and multipolygon
            NSToolDraw.f_draw_polygon_enable(o_geojson_feature_geometry);
        }


    },

    f_execute_save: function()
    {
        //alert("clicked save!");

        let this_ = this;

        let o_client_info = NSMiniClientMain.f_get_current_client_info();
        let s_schema_internal_name = o_client_info.schema;
        let s_table_internal_name = o_client_info.table;
        let s_geometry_internal_name = o_client_info.geometry;
        let o_col_info = NSDataModelInfo.f_get_field_info(s_schema_internal_name, s_table_internal_name, s_geometry_internal_name);
        let s_table_urn = NSURN.f_create_table_urn(s_schema_internal_name, s_table_internal_name);
        


        //1
        let b_geometry_is_valid;
        let s_geometry_type = o_col_info.data_type;
        if( NSDataTypes.f_geometry_type_is_point(s_geometry_type) )
        {
            b_geometry_is_valid = NSToolDraw.f_draw_marker_is_active_and_a_marker_is_drawn();
        }
        else if (NSDataTypes.f_geometry_type_is_polyline(s_geometry_type) )
        {
            b_geometry_is_valid = NSToolDraw.f_draw_polyline_is_active_and_a_line_is_drawn();
        }
        else
        {
            b_geometry_is_valid = NSToolDraw.f_draw_polygon_is_active_and_an_area_is_drawn();
        }
        
        if(!b_geometry_is_valid)
        {
            let s_message = NSPageLabels.f_get_label_text_by_internal_name("obj_details_edit_geometry_check_error");
            NSMessages.f_show_information(s_message);
            return;
        }

        // 2 - geometry data:
        
        let o_gj_feature = NSToolDraw_.f_get_drawn_geometry_as_geo_json_feature();
        let o_field_geo_value = (o_gj_feature!=null)? o_gj_feature.geometry : null;
        if(o_field_geo_value != null
            && NSDataTypes.f_geometry_type_is_multipolygon(s_geometry_type)
            && NSGeoJson.f_geojson_feature_geometry_is_of_type_polygon(o_field_geo_value)
        )
        {
            let o_geojson_feature_geometry_polygon = o_field_geo_value; 
            o_field_geo_value = NSGeoJson.f_get_geojson_feature_geometry_of_type_multipolygon_from_polygon(o_geojson_feature_geometry_polygon);
        }

        let o_geojson_feature_geometry = o_field_geo_value;
        let s_geojson_feature_geometry = (o_geojson_feature_geometry!=null)? JSON.stringify(o_geojson_feature_geometry) : null;

        let a_bounds_list =[];
        let b_geometry_changes_implies_tiles_update = true;
        if(b_geometry_changes_implies_tiles_update)
        {
            let a_bounds = null;
            if(private_objs.o_details != null)
            {
                let o_original_geojson_feature_geometry = private_objs.o_details.feature.properties[s_geometry_internal_name];

                a_bounds = NSGeoJson.f_get_bounds_from_geojson_geometry(o_original_geojson_feature_geometry);
                if(a_bounds!=null)
                {
                    a_bounds_list.push({"x_min": a_bounds[0], "y_min": a_bounds[1], "x_max": a_bounds[2], "y_max": a_bounds[3]});
                }
            }

            a_bounds = NSGeoJson.f_get_bounds_from_geojson_geometry(o_geojson_feature_geometry);
            if(a_bounds!=null)
            {
                a_bounds_list.push({"x_min": a_bounds[0], "y_min": a_bounds[1], "x_max": a_bounds[2], "y_max": a_bounds[3]});
            }
        }


        // key value
        let s_key_col = o_client_info.key_column;
        let key_value = private_objs.miniclient_input.id;

        // id value
        let s_record_id = null;
        if(private_objs.o_details != null)
        {
            let s_feature_urn = private_objs.o_details.s_urn;
            let a_feature_urn_info = NSURN.f_get_urn_info(s_feature_urn);
            s_record_id = a_feature_urn_info[3];
        }


        //preparing service input
        let a_input_params = [];
        a_input_params.push(
            {
                "name": s_key_col, "value": key_value
            });
        if(s_record_id != null) // if update
        {
            a_input_params.push(
                {
                    "name": private_objs.o_CONSTS.s_ID_COL_NAME_FOR_ALL_TABLES, "value": s_record_id
                });
        }
        else //insert
        {
            if(private_objs.o_CONSTS.s_ID_COL_NAME_FOR_ALL_TABLES != s_key_col) // add id column with null value
            {
                //adding new element to head of the array
                a_input_params.unshift({"name": private_objs.o_CONSTS.s_ID_COL_NAME_FOR_ALL_TABLES, "value": null});
            }

        }
        a_input_params.push(
            {
                "name": s_geometry_internal_name, "value": s_geojson_feature_geometry
            });

        
        let o_upsert_in =
        {
            "table_urn": s_table_urn,
            "input_params": a_input_params                    
        };

        if(b_geometry_changes_implies_tiles_update && a_bounds_list != null && a_bounds_list.length>0)
        {
            o_upsert_in.update_tiles =	{
                                            "b_update_tiles" : true,
                                            "a_bounds_list": a_bounds_list
                                        };
        }
        
        let f_cb = function (o_resp)
        {
            this_.f_call_upsert_process_result_(o_resp);
        }
        
        NSServerCalls.f_edit_obj_upsert(o_upsert_in, f_cb);



        
    },

    f_call_upsert_process_result_: function(o_resp)
    {
        if( o_resp != null && o_resp.success ==true )
        {
            
            let o_details = private_objs.o_details;
            
            let o_client_info = NSMiniClientMain.f_get_current_client_info();
            let s_schema_internal_name = o_client_info.schema;
            let s_table_internal_name = o_client_info.table;

            let s_table_urn = NSURN.f_create_table_urn(s_schema_internal_name, s_table_internal_name);
            //Overlays.f_refresh_layer_by_tree_node_id(o_details.tree_node_id);
            Overlays.f_refresh_layers_by_table_urn(s_table_urn);

            let s_record_id = o_resp.output_params[0].value;
            let s_record_urn = NSURN.f_create_record_urn_from_table_urn(s_table_urn , s_record_id);
            
            //alert ("s_record_urn= "+s_record_urn);
            window.parent.postMessage({event_id: 'SIGSavePolygon',  data: { urn: s_record_urn }},"*");

            
            NSMessages.f_show_information("Operação bem sucedida");

            f_reload_object_and_edit_data();


        }
        else{
            var s_error_message = NSPageLabels.f_get_label_text_by_internal_name("obj_details_edit_save_error");
            
            if(o_resp != null && o_resp.error != null && o_resp.error != "")
            {
                s_error_message += ":<br><br>" + o_resp.error;
            }
            else
            {
                s_error_message += ".";
            }
            NSMessages.f_show_information(s_error_message);
            
            
        }
    }


}


window.NSMiniClientMain_ = NSMiniClientMain;
NSMiniClientMain.private_objs = private_objs;

